module.exports = __webpack_public_path__ + "img/config.b074ecd7.svg";